import { render, staticRenderFns } from "./MembershipCard.vue?vue&type=template&id=63c7fcb4&"
import script from "./MembershipCard.vue?vue&type=script&lang=ts&"
export * from "./MembershipCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports